import styled from 'styled-components';

export const AutocompleteList = styled.div`
  position: absolute;
  z-index: 1;
  top: 38px;
  left: 0;
  border-radius: 4px;
  width: 230px;
  max-height: 228px;
  overflow: auto;
  border: 1px solid;
  border-color: ${(props) => props.theme.colors['neutral-30']};
  background: ${(props) => props.theme.colors['neutral-10']};
  box-shadow: 0px 4px 6px 0px rgba(0, 0, 0, 0.07);
`;

export const GroupedOptionsSubtitle = styled.p`
  font-size: 9px;
  line-height: 10px;
  padding: 11px 12px;
  text-transform: uppercase;
  color: ${(props) => props.theme.colors['neutral-80']};
`;

export const AutocompleteListItem = styled.li``;

export const AutocompleteListButton = styled.button`
  padding: 6px 12px;
  font-size: 14px;
  line-height: 21px;
  cursor: pointer;
  display: block;
  width: 100%;
  text-align: left;
  color: ${(props) => props.theme.colors['neutral-100']};
  &:hover {
    background: ${(props) => props.theme.colors['neutral-20']};
  }
  * {
    display: flex;
    align-items: center;
  }
  &:disabled * {
    justify-content: center;
    cursor: auto;
  }
`;

export const InputText = styled.input`
  width: 100%;
  padding: 5px 12px;
  color: red;
  font-weight: 400;
  line-height: 21px;
  font-size: 14px;
  color: ${(props) => props.theme.colors['neutral-100']};
  border: 0;
  border-bottom: 1px solid;
  border-color: ${(props) => props.theme.colors['neutral-30']};
`;
